import AnalyticsBase from './AnalyticsBase';

class LinkTrackingEvent extends AnalyticsBase {
  linkid: string;

  linktype: string;
}

export default LinkTrackingEvent;
